import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';
import { toast } from 'components/Shared/Toast';

import packageJson from '../package.json';
import { Growl } from 'components/Shared/Growl';
global.appVersion = packageJson.version;

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_RELEASE) {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DNS,
        release: process.env.REACT_APP_SENTRY_RELEASE,
        maxBreadcrumbs: 1,
        environment: process.env.REACT_APP_ENVIRONMENT_NAME
    });
}

// version from response - first param, local version second param
const semverGreaterThan = (versionA, versionB) => {
    const versionsA = versionA.split(/\./g);

    const versionsB = versionB.split(/\./g);
    while (versionsA.length || versionsB.length) {
        const a = Number(versionsA.shift());

        const b = Number(versionsB.shift());
        // eslint-disable-next-line no-continue
        if (a === b) continue;
        // eslint-disable-next-line no-restricted-globals
        return a > b || isNaN(b);
    }
    return false;
};

export default function CacheBuster({ children }) {

    const { t } = useTranslation();

    const currentVersion = global.appVersion;

    console.info(`Version: ${currentVersion}`)

    useEffect(() => {
        function validate() {
            fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-cache' })
                .then((response) => response.json())
                .then((meta) => {
                    const latestVersion = meta.version;

                    const shouldForceRefresh = semverGreaterThan(latestVersion, currentVersion);
                    if (shouldForceRefresh) {
                        toast.dark(Growl({
                            translated: t('instrumentation.new_version', {
                                replace: { latestVersion }
                            }),
                        }), {
                            position: 'top-right',
                            autoClose: false,
                            onClose: () => {
                                refreshCacheAndReload();
                            }
                        });
                    }
                });
        }
        validate();
        setTimeout(() => {
            validate()
        }, 600000)
    }, []);

    const refreshCacheAndReload = useCallback(async () => {
        console.log('Clearing cache and hard reloading...')
        if (caches) {
            const names = await caches.keys();
            await Promise.all(names.map(name => caches.delete(name)));
        }

        // delete browser cache and hard reload
        window.location.reload(true);
    }, []);

    return children;
}
